<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 102" class="link-radio-inner">
		<circle cx="51" cy="51" r="42" class="link-radio-inner-out"/>
		<circle cx="51" cy="51" r="17" class="link-radio-inner-in" v-if="checked"/>
	</svg>
</template>

<script>
	export default {
		name: "link-radio-inner",
		props: {
			checked: {type: Boolean},
		},
	}
</script>

<style lang="scss">
	.link-radio-inner {
		width: 1em;
		height: 1em;
		transform: scale(1.2);

		circle {
			stroke-width: 4;
		}

		.link-radio-inner-out {
			stroke: currentColor;
			fill: transparent;
		}

		.link-radio-inner-in {
			stroke: currentColor;
			fill: currentColor;
		}
	}
</style>